import React from "react";
import { connect } from "react-redux";
import { apiActions } from "../../apiCall/api.services";
import { loginUser } from "../../actions/authActions";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { confirmAlert } from 'react-confirm-alert';
import CagCaptcha from '../../components/CagCaptcha';

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from "reactstrap";

class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      username: "",
      password: "",
      allData: "",
      domain: "",
      captchaValid: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  preventIllegalChange(event) {
    if (event.key === "Enter")
      event.preventDefault();
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();

    if (!this.state.captchaValid) {
      confirmAlert({
        title: 'Hata',
        message: 'Lütfen güvenlik doğrulamasını tamamlayın.',
        buttons: [
          {
            label: 'Tamam',
            onClick: () => { }
          },
        ],
      });
      return;
    }

    const userData = {
      username: this.state.username,
      password: this.state.password,
    };

    this.props.loginUser(userData);
  }

  getData() {
    let currentComponent = this;
    let promise2 = apiActions.onLoadApi();
    promise2.then(function (val) {
      console.log(val);
      currentComponent.setState({ allData: val.data[0] });
    });
  }

  handleCaptchaResult = (isValid) => {
    this.setState({ captchaValid: isValid });
  }
  componentDidMount() {
    this.getData();

    const urlLocation = window.location.hostname;
    console.log("urlLocation", urlLocation);
    this.setState({ domain: urlLocation });
  }

  render() {
    return (
      <>
        <Col lg="5" md="7">
          <Card className="bg-secondary shadow border-0">
            <CardBody className="px-lg-5 py-lg-5">
              <div className="text-center text-muted mb-4">
                <img src={this.state.allData} alt="" width="200" />
              </div>
              <Form role="form" onSubmit={this.handleSubmit}>
                <FormGroup className="mb-3">
                  <InputGroup className="input-group-alternative">
                    <InputGroupText>
                        <i className="ni ni-email-83" />
                    </InputGroupText>
                    <Input
                      placeholder="Kullanıcı Adı"
                      id="username"
                      name="username"
                      type="text"
                      required
                      onChange={this.handleChange}
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup className="input-group-alternative">
                    <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                    <Input
                      placeholder="Şifre"
                      id="password"
                      name="password"
                      type="password"
                      required
                      onChange={this.handleChange}
                    />
                  </InputGroup>
                </FormGroup>
                {/* <div className="custom-control custom-control-alternative custom-checkbox">
                  <input
                    className="custom-control-input"
                    id=" customCheckLogin"
                    type="checkbox"
                  />
                  <label
                    className="custom-control-label"
                    htmlFor=" customCheckLogin"
                  >
                    <span className="text-muted">Beni Hatırla</span>
                  </label>
                </div> */}
                <div className="text-center mb-3">
                  <CagCaptcha resultFunc={this.handleCaptchaResult} />
                </div>
                <div className="text-center">
                  <Button className="my-4" color="primary" type="submit">
                    Giriş
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>

          {this.state.domain === "tchibodestek.servissoft.net" && (
            <>
              <Row className="mt-3">
                <Col xs="6">
                  <a className="text-light" href="/auth/forgot-password">
                    <small>Şifremi Unuttum</small>
                  </a>
                </Col>
              </Row>
            </>
          )
          }

          {this.state.domain !== "tchibodestek.servissoft.net" && (
            <>

              <Row className="mt-3">
                <Col xs="6">
                  <a className="text-light" href="/auth/forgot-password">
                    Şifremi Unuttum
                  </a>
                </Col>
                <Col className="text-right" xs="6">
                  <a className="text-light" href="/auth/register">
                    Yeni Hesap Oluştur
                  </a>
                </Col>
              </Row>

            </>)}
          {this.state.domain === "ferreservis.com" && (
            <>
              <Row className="mt-3">
                <Col xs="12" className="text-center">
                  <p
                    style={{ color: "#ffffff", padding: 10 }}
                  >
                    <small>"Yeni Hesap Oluştur" alanından hesap oluşturarak giriş yapabilirsiniz.<br />
                      Sms olarak gelen kullanıcı adı ve şifrenizle servis kaydı açabilir ürünlerinize ait yapılan servis işlemlerinizin tamamını takip edebilirsiniz.</small>
                  </p>
                </Col>
              </Row>
            </>)}

          {this.state.domain === "servis.ttteknoloji.com.tr" && (
            <>
              <Row className="mt-3">
                <Col xs="12" className="text-center">
                  <a
                    style={{ color: "#ffffff", padding: 10 }}
                    href="tel:08503460822"
                  >
                    0850 346 08 22
                  </a>
                </Col>
              </Row>

              <Row className="mt-3">
                <Col xs="12" className="text-center">
                  <a
                    style={{ color: "#ffffff", padding: 10 }}
                    href="mailto:destek@ttteknoloji.com.tr"
                  >
                    destek@ttteknoloji.com.tr
                  </a>
                </Col>
              </Row>

              <Row className="mt-3">
                <Col xs="12" className="text-center">
                  <a
                    style={{ color: "#ffffff", padding: 10 }}
                    href="https://www.ttteknoloji.com.tr"
                  >
                    ttteknoloji.com.tr
                  </a>
                </Col>
              </Row>

              <Row className="mt-3">
                <Col xs="12" className="text-center">
                  <a
                    style={{ color: "#ffffff", padding: 10 }}
                    href="https://twitter.com/tt_teknoloji"
                  >
                    <TwitterIcon />
                  </a>
                  <a
                    style={{ color: "#ffffff", padding: 10 }}
                    href="https://www.facebook.com/TT-Teknoloji-187336168288047/"
                  >
                    <FacebookIcon />
                  </a>
                  <a
                    style={{ color: "#ffffff", padding: 10 }}
                    href="https://tr.linkedin.com/company/tt-teknoloji"
                  >
                    <LinkedInIcon />
                  </a>

                  <a
                    style={{ color: "#ffffff", padding: 10 }}
                    href="https://www.youtube.com/channel/UCeOjXnWliPITy-lyrUTuYhg?view_as=subscriber"
                  >
                    <YouTubeIcon />
                  </a>
                  <a
                    style={{ color: "#ffffff", padding: 10 }}
                    href="https://www.instagram.com/ttteknolojiofficial/"
                  >
                    <InstagramIcon />
                  </a>
                </Col>
              </Row>
            </>
          )}
          {this.state.domain === "servis.goldmaster.com.tr" && (
            <>
              <Row className="mt-3">
                <Col xs="12" className="text-center">
                  <a
                    style={{ color: "#ffffff", padding: 10 }}
                    href="tel:08505325666"
                  >
                    0850 532 56 66
                  </a>
                </Col>
              </Row>



              <Row className="mt-3">
                <Col xs="12" className="text-center">
                  <a
                    style={{ color: "#ffffff", padding: 10 }}
                    href="goldmaster.com.tr"
                  >
                    goldmaster.com.tr
                  </a>
                </Col>
              </Row>

              <Row className="mt-3">
                <Col xs="12" className="text-center">
                  <a
                    style={{ color: "#ffffff", padding: 10 }}
                    href="https://twitter.com/goldmasterworld"
                  >
                    <TwitterIcon />
                  </a>
                  <a
                    style={{ color: "#ffffff", padding: 10 }}
                    href="https://www.facebook.com/Goldmasterworld"
                  >
                    <FacebookIcon />
                  </a>
                  <a
                    style={{ color: "#ffffff", padding: 10 }}
                    href="https://www.linkedin.com/company/goldmaster/"
                  >
                    <LinkedInIcon />
                  </a>

                  <a
                    style={{ color: "#ffffff", padding: 10 }}
                    href="https://www.youtube.com/goldmasterworld"
                  >
                    <YouTubeIcon />
                  </a>
                  <a
                    style={{ color: "#ffffff", padding: 10 }}
                    href="https://www.instagram.com/goldmasterworld/"
                  >
                    <InstagramIcon />
                  </a>
                </Col>
              </Row>
            </>
          )}
        </Col>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { loginUser })(Login);

/*
import React from "react";
import { connect } from "react-redux";
import loginAction from "actions/loginAction";
import { apiActions } from "../../apiCall/api.services";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupText,
  InputGroup,
  Row,
  Col
} from "reactstrap";

class Login extends React.Component {

  state = {
    email: "",
    password: "",
    allData:""
  }

  onChange = (stateName,value) => {
    this.setState({
      [stateName]: value
    })
  }

  
  getData(){
        let currentComponent = this;
        let promise2 = apiActions.onLoadApi();    
        promise2.then(function(val){
            console.log(val);
            currentComponent.setState({allData:val.data[0]});
        });
  }

  componentDidMount() {
         this.getData();
  }

  render() {
    return (
      <>
        <Col lg="5" md="7">
          <Card className="bg-secondary shadow border-0">
            <CardBody className="px-lg-5 py-lg-5">
              <div className="text-center text-muted mb-4">
                <img src={this.state.allData} alt="" />    
              </div>
              <Form role="form" onSubmit={this.handleSubmit}>
                <FormGroup className="mb-3">
                  <InputGroup className="input-group-alternative">
                    <InputGroupText>
                        <i className="ni ni-email-83" />
                    </InputGroupText>
                    <Input placeholder="Email" type="email" onChange={
                      e=>this.onChange(
                        "email",
                        e.target.value
                      )
                    } />
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup className="input-group-alternative">
                    <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                    <Input placeholder="Password" type="password" onChange={
                      e=>this.onChange(
                        "password",
                        e.target.value
                      )
                    } />
                  </InputGroup>
                </FormGroup>
                <div className="custom-control custom-control-alternative custom-checkbox">
                  <input
                    className="custom-control-input"
                    id=" customCheckLogin"
                    type="checkbox"
                  />
                  <label
                    className="custom-control-label"
                    htmlFor=" customCheckLogin"
                  >
                    <span className="text-muted">Remember me</span>
                  </label>
                </div>
                <div className="text-center">
                  <Button className="my-4" color="primary" type="button" onClick={
                    ()=>{
                      this.props.loginAction(
                          this.state.email,
                          this.state.password
                      )
                    }
                  }>
                    Sign in
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
          <Row className="mt-3">
            <Col xs="6">
              <a
                className="text-light"
                href="/auth/forgot-password"
              >
                <small>Forgot password?</small>
              </a>
            </Col>
            <Col className="text-right" xs="6">
              <a
                className="text-light"
                href="/auth/register"
              >
                <small>Create new account</small>
              </a>
            </Col>
          </Row>
        </Col>
      </>
    );
  }
}

const mapStateToPropos = (state) => {
  //console.log(state.auth);
  return{
      
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    loginAction: (email,password) => 
      dispatch(
      loginAction(
        email,password
      ))
  }
}

export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(Login);

*/
